import React from "react";

const VARIANT_STYLES = {
  primary:
    "border-indigo-200 bg-indigo-50 text-indigo-700 hover:bg-indigo-100 focus-visible:ring-indigo-500",
  success:
    "border-emerald-200 bg-emerald-50 text-emerald-800 hover:bg-emerald-100 focus-visible:ring-emerald-500",
  warning:
    "border-amber-200 bg-amber-50 text-amber-900 hover:bg-amber-100 focus-visible:ring-amber-500",
  destructive:
    "border-red-200 bg-red-50 text-red-700 hover:bg-red-100 focus-visible:ring-red-500",
  neutral:
    "border-gray-200 bg-white text-gray-700 hover:bg-gray-50 focus-visible:ring-gray-400",
};

const resolveVariant = (action) => {
  if (action.variant) {
    return action.variant;
  }

  if (action.destructive) {
    return "destructive";
  }

  if (action.id === "read_only_on") {
    return "warning";
  }

  if (action.id === "read_only_off") {
    return "neutral";
  }

  if (action.id === "send_outstanding_reminder" || action.id === "extend_trial") {
    return "primary";
  }

  return "primary";
};

const FinancialQueueActionButtons = ({ actions = [], onAction, row, layout = "stack" }) => {
  if (!actions.length) {
    return <span className="text-xs text-gray-400">—</span>;
  }

  const containerClass =
    layout === "inline"
      ? "flex min-w-[12rem] flex-wrap gap-1.5"
      : "flex min-w-[9.5rem] flex-col gap-1.5";

  return (
    <div className={containerClass}>
      {actions.map((action) => {
        const variant = resolveVariant(action);

        return (
          <button
            key={action.id}
            type="button"
            onClick={() => onAction(action.id, row)}
            title={action.title || action.label}
            className={`inline-flex w-full items-center justify-center rounded-md border px-2.5 py-1.5 text-xs font-medium shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 sm:w-auto ${VARIANT_STYLES[variant]}`}
          >
            {action.label}
          </button>
        );
      })}
    </div>
  );
};

export default FinancialQueueActionButtons;
